import Costs_CostsPage from "@Quest/Costs/Pages/CostsPage.vue";

export const routes = [
    {
        path: "/enterprise/costs/:workspaceId/:strategyId",
        component: Costs_CostsPage
    },
]
